import { useNavigate } from "react-router-dom";
import { IconArrowLeft } from "@tabler/icons-react";
import { AppRoutes } from "../../../../common/routes/app_routes";
import { Heading, Text } from "../../../../components/common/typography";
import AuthBrandPanel from "../components/auth-brand-panel";
import { ForgotPasswordForm } from "../components/forgot_password_form";

const ForgotPasswordPage = () => {
  const navigate = useNavigate();

  return (
    <main className="flex min-h-screen w-full bg-bgWhite">
      <div className="sticky top-0 hidden h-screen w-1/2 shrink-0 lg:block">
        <AuthBrandPanel />
      </div>

      <section className="flex min-h-screen flex-1 flex-col px-4 sm:px-12">
        <div className="pt-6">
          <button
            type="button"
            onClick={() => navigate(AppRoutes.LOGIN)}
            aria-label="Back to login"
            className="flex items-center justify-center text-textBody transition-colors hover:text-textDark"
          >
            <IconArrowLeft size={22} />
          </button>
        </div>

        <div className="flex flex-1 items-center justify-center pb-48">
          <div className="flex w-full max-w-[528px] flex-col items-center gap-8">
            <div className="flex flex-col items-center gap-6 text-center">
              <Heading variant="h2" tone="dark">Forgot password?</Heading>
              <Text variant="body" tone="body" className="max-w-lg">
                Enter the email address associated with your account below to reset your password.
              </Text>
            </div>

            <div className="w-full">
              <ForgotPasswordForm />
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ForgotPasswordPage;
